import React, { Component } from "react";
import { Nav, NavbarBrand, NavbarToggler } from "reactstrap";
import HeaderDropdown from "./HeaderDropdown";
import AuthService from "../../components/AuthService";

class Header extends Component {
  constructor(props) {
    super(props);
    this.Auth = new AuthService();
    this.state = {};
  }

  componentDidMount() {
    this.fetchCompanyName(this);
  }

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-hidden");
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-minimized");
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-mobile-show");
  }

  fetchCompanyName(thus) {
    this.Auth.httpRequest("GET", "api/user/selectCompany")
      .then(function(datas) {
        thus.setState(previousState => ({
          companyName: datas.data[0].name
        }));
      })
      .catch(error => console.log(error));
  }

  render() {
    return (
      <header className="app-header navbar">
        <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>
          <span className="navbar-toggler-icon" />
        </NavbarToggler>
        <NavbarBrand href="#" />
        <NavbarToggler className="d-md-down-none" onClick={this.sidebarToggle}>
          <span className="navbar-toggler-icon" />
        </NavbarToggler>
        <span>{this.state.companyName}</span>
        <Nav className="ml-auto" navbar style={{ marginRight: 1 + "%" }}>
          <HeaderDropdown />
        </Nav>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js